import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { hsnModel } from '../model/index';

@Injectable()
export class HsnService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private hsnUrl = 'api/hsn';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getHSNList(query: any): Promise<hsnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.hsnUrl}/getHSNList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteHSN(hsn_id: any): Promise<hsnModel> {
        const url = `${this.hsnUrl}/deleteHSN`;
        return this.http
            .post(url, $.param({ hsn_id: hsn_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as hsnModel)
            .catch(this.handleError);
    }

    addUpdateHSN(hsnData: any): Promise<hsnModel> {

        const url = `${this.hsnUrl}/addUpdateHSN`;

        return this.http
            .post(url, $.param(hsnData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as hsnModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/hsn.service.ts